//Nothing required at the moment - thunks replaced with react-query

const initialState = {}

export default function reducer(state = initialState, action: any) {
    switch (action.type) {
        default: return state
    }
}
